import React from 'react';

import { IRelatedLinks } from '@/utility/social-distancing-data';
interface IProps {
  links: IRelatedLinks[];
}
const CrossLinks: React.FC<IProps> = ({ links }) => (
  <>
    {links.map(({ title, url }) => (
      <a
        href={url}
        title={title}
        key={title}
        className="flex justify-start w-full pr-6 mb-1 text-sm text-gray-900 no-underline md:w-1/3 xs:w-1/2 md:text-base hover:underline underline-offset-2">
        {title}
      </a>
    ))}
  </>
);

export default CrossLinks;
